import { render, staticRenderFns } from "./ImportacaoLateral.vue?vue&type=template&id=69760dd8&lang=html"
import script from "./ImportacaoLateral.vue?vue&type=script&lang=js"
export * from "./ImportacaoLateral.vue?vue&type=script&lang=js"
import style0 from "./ImportacaoLateral.vue?vue&type=style&index=0&id=69760dd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports